import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function LatestArticles() {
  const latest = articles.filter((a) => !a.featured).slice(0, 6);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            最新教程
          </h2>
          <p className="text-sm text-foreground-600 mt-3 max-w-xl mx-auto">
            持续更新的P站视频使用技巧，帮助你不断提升平台使用效率
          </p>
        </div>

        <div className="space-y-4">
          {latest.map((article) => (
            <ArticleCard key={article.slug} article={article} variant="default" />
          ))}
        </div>
      </div>
    </section>
  );
}